import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Item = styled(RouterLink)`
  position: relative;
  display: grid;
  align-items:  ${props => props.theme.alignItems || 'center'};
  word-break: break-word;
  grid-template-columns: ${props =>
    props.theme.gridTemplateColumns || '50px 1fr'};
  grid-gap: ${props => props.theme.gridGap.default};
  min-height: ${props => props.theme.minHeight.default};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border-bottom: ${props => `3px solid ${props.theme.borderColor}`};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;

  &:after {
    position: absolute;
    content: '${props => (props.theme.after ? props.theme.after.content : '')}';
    top: 50%;
    right: 5px;
    transform: rotate(270deg);
    transform-origin: top;
    transition: 0.2s all;
    background-color: ${props =>
      props.theme.after && props.theme.after.backgroundColor};
    color: ${props => props.theme.after && props.theme.after.color};
    font-family: ${props => props.theme.after && props.theme.after.fontFamily};
    font-size: ${props =>
      props.theme.after && `${props.theme.after.fontSize}rem`};
    line-height: ${props => props.theme.after && props.theme.after.lineHeight};
    font-weight: ${props => props.theme.after && props.theme.after.fontWeight};
    padding: ${props => props.theme.after && props.theme.after.padding};
  }

  &:hover:after {
    background-color: ${props =>
      props.theme.after && props.theme.after.backgroundColorOnHover};
  }

  ${Media.md`
    grid-gap: ${props => props.theme.gridGap.md};
    min-height: ${props => props.theme.minHeight.md};
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};

    &:after {
      right: 0;
      font-size: ${props =>
        props.theme.after && `${props.theme.after.fontSizeMd}rem`};
      padding: ${props => props.theme.after && props.theme.after.paddingMd};
    }
  `}

  ${props =>
    props.isCollection &&
    css`
      border-top: ${props => props.theme.border};
    `}

    ${props =>
      props.isFirstCollection &&
      css`
        border-top: ${props => props.theme.borderFirstTop};
      `}

  ${props =>
    props.isLastCollection &&
    css`
      border-bottom: ${props => props.theme.borderLastBottom};
      border-color: ${props => props.theme.borderLastBottomColor};
    `}
`;

export const ItemExternal = styled.a`
  position: relative;
  display: grid;
  align-items:  ${props => props.theme.alignItems || 'center'};
  word-break: break-word;
  grid-template-columns: ${props =>
    props.theme.gridTemplateColumns || '50px 1fr'};
  grid-gap: ${props => props.theme.gridGap.default};
  min-height: ${props => props.theme.minHeight.default};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border-bottom: ${props => `3px solid ${props.theme.borderColor}`};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;

  ${Media.md`
    grid-gap: ${props => props.theme.gridGap.md};
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${props =>
    props.isCollection &&
    css`
      border-top: ${props => props.theme.border};
    `}

    ${props =>
      props.isFirstCollection &&
      css`
        border-top: ${props => props.theme.borderFirstTop};
      `}

  ${props =>
    props.isLastCollection &&
    css`
      border-bottom: ${props => props.theme.borderLastBottom};
    `}
`;

export const Imagebox = styled.div`
  display: ${props => props.theme.display || 'block'};
  width: ${props => props.theme.width || '50px'};
  height: ${props => props.theme.height || '50px'};
  margin: ${props => props.theme.margin.default};

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borderRadius.default};

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;

export const Text = styled.h3`
  display: block;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding && props.theme.padding.default};
  color: ${props => props.theme.color};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Arrow = styled.i`
  display: ${props => props.theme.display || 'inline-flex'};
  align-items: center;
  justify-content: center;
  min-width: ${props => props.theme.minWidth};
  min-height: ${props => props.theme.minHeight};
  margin: 0 0 0 5px;
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  vertical-align: middle;
  border-radius: ${props => props.theme.borderRadius.default};
  transition: .2s all;

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${props =>
    props.theme.invert &&
    css`
      background: ${props => props.theme.color};
      color: ${props => props.theme.background};
    `}

  ${props =>
    props.theme &&
    props.theme.position &&
    props.theme.position === 'right-center' &&
    css`
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    `}

  ${Item}:hover &, ${ItemExternal}:hover &{
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};

    ${props =>
      props.theme.invert &&
      css`
        background: ${props => props.theme.colorOnHover};
        color: ${props => props.theme.backgroundOnHover};
      `}
  }
`;
export const TextBox = styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  height: 100%;
`;
export const ReadMore = styled.div`
  display: block;
  align-self: end;
  color: ${props => props.theme.color};
  font-weight: ${props => props.theme.fontWeight};
  font-size: ${props => `${props.theme.fontSize}rem`};
  ${Item}:hover &,
  ${ItemExternal}:hover & {
    color: ${props => props.theme.colorOnHover};
  }
`;
